import React from "react";
import {
  Empty,
  List,
  Typography,
  Space,
  Flex,
  Row,
  Col,
  Button,
  Popconfirm,
} from "antd";
import {
  FileTextOutlined,
  CalendarOutlined,
  UserOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import formatDate from "utilities/formats/formatDate";

const { Text } = Typography;

const DocumentationContent = ({ documentation, editable, deleteDoc }) => {
  return documentation.length > 0 ? (
    <List
      itemLayout="vertical"
      dataSource={documentation}
      renderItem={(item) => (
        <List.Item>
          <List.Item.Meta
            avatar={<FileTextOutlined />}
            title={
              item.documentType ? (
                <Text strong>{item.documentType}</Text>
              ) : (
                "Unkown Type"
              )
            } // Emphasize the document type
            description={
              <Row gutter={[8, 0]} align="middle">
                <Col xs={24} sm={12} md={8} lg={8}>
                  {item.documentNumber && (
                    <Space>
                      <Text strong>Number:</Text>
                      <Text>{item.documentNumber}</Text>
                    </Space>
                  )}
                </Col>
                <Col xs={24} sm={12} md={8} lg={8}>
                  {item.documentDate && (
                    <Space>
                      <Text strong>Date:</Text>
                      <CalendarOutlined />
                      <Text>{formatDate(item.documentDate)}</Text>
                    </Space>
                  )}
                </Col>
                <Col xs={24} sm={12} md={8} lg={8}>
                  {item.sasUrl && (
                    <Flex justify="end">
                      <Space direction="vertical" size={0} align="center">
                        <Button
                          type="link"
                          icon={<DownloadOutlined />}
                          href={item.sasUrl}
                        >
                          Download
                        </Button>
                        <Text type="secondary" style={{ fontSize: "12px" }}>
                          {item.documentName}
                        </Text>
                      </Space>
                    </Flex>
                  )}
                </Col>
                <Col xs={24} sm={18} md={18} lg={20}>
                  <Text
                    type="secondary"
                    strong
                    style={{ display: "block", marginBottom: 4 }}
                  >
                    Upload Information
                  </Text>
                  <Space>
                    <CalendarOutlined />
                    <Text type="secondary">
                      {formatDate(item.uploadedDate)}
                    </Text>
                    <UserOutlined />
                    <Text type="secondary">
                      {item.uploadedBy.firstName} {item.uploadedBy.lastName} (
                      {item.uploadedBy.initials})
                    </Text>
                  </Space>
                </Col>
                {editable && (
                  <Popconfirm
                    title="Are you sure you want to remove this document?"
                    onConfirm={() => deleteDoc(item.id)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Col
                      xs={24}
                      sm={6}
                      md={6}
                      lg={4}
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button type="text" danger>
                        Remove
                      </Button>
                    </Col>
                  </Popconfirm>
                )}
              </Row>
            }
          />
        </List.Item>
      )}
    />
  ) : (
    <Empty description="No Documentation Available" />
  );
};

export default DocumentationContent;
